export default __webpack_public_path__ + "static/natura11y-icons-sprite-f6e8101f3de8da269ef77f86ea88a4ce.svg";